// Centralized brand constants
export const NEURO_LOGO_URL = `${process.env.PUBLIC_URL || ""}/neuro-logo.png`;

export const BRAND_CHART_COLORS = {
  purple: "hsl(271 70% 55%)",
  cyan: "hsl(198 90% 60%)",
  magenta: "hsl(295 75% 62%)",
  periwinkle: "hsl(220 80% 68%)",
  pink: "hsl(320 75% 65%)",
};
